import { LANGUAGES } from 'settings/languages';

export const getLanguages = async () => {
  return await new Promise((resolve) => resolve(LANGUAGES));
};